
import { defineComponent } from "vue";

export default defineComponent({
  name: "BotaoForm",
  emits: ['clicado'],
  props: {
    desabilitado: {
        type: Boolean
    },
    icone: {
        type: String,
        required: true
    },
    texto: {
        type: String,
        required: true
    }
  },
  methods: {
    clicado() : void {
        this.$emit('clicado')
    }
  }

});
